var _isReady = false;
var _pendingPageView = null;

function getMeasurementId() {
  var hostname = window.location.hostname.toLowerCase();
  if (hostname.includes('local')) return 'G-J4T5WWDLBM';
  if (hostname.includes('dev')) return 'G-VH22LGZMB8';
  if (hostname.includes('qa')) return 'G-NFK6TF1NK4';
  return 'G-MHYM2Q89HN';
}

export function setUserProperties(userProfile, globalConfig) {
  if (typeof window.gtag !== 'function') return;
  const oid = userProfile?.UserId;
  const measurementId = getMeasurementId();
  window.gtag('set', { user_id: oid });
  window.gtag('config', measurementId, { user_id: oid, send_page_view: false });
  const userTitle =
    globalConfig?.observationConfig?.UserPositionAlternativeMap?.[userProfile?.UserPositionType]
    ?? userProfile?.Title;
  window.gtag('set', 'user_properties', {
    user_roles: userProfile?.Roles,
    user_title: userTitle,
    org_name: globalConfig?.OrganizationNames,
    district_name: globalConfig?.DistrictNames,
    school_name: globalConfig?.SchoolNames,
    user_profile_id: userProfile?.UserId,
  });
  _isReady = true;
  if (_pendingPageView) {
    const { title, path } = _pendingPageView;
    _pendingPageView = null;
    trackPageView(title, path);
  }
}

export function trackPageView(title, path) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) {
    _pendingPageView = { title, path };
    return;
  }
  window.gtag('event', 'page_view', {
    page_title: title,
    page_path: path,
    page_location: window.location.href,
  });
}

export function clearUser() {
  _isReady = false;
  _pendingPageView = null;
  if (typeof window.gtag !== 'function') return;
  const measurementId = getMeasurementId();
  window.gtag('config', measurementId, { user_id: undefined, send_page_view: false });
  window.gtag('set', 'user_properties', {
    user_roles: null,
    user_title: null,
    org_name: null,
    district_name: null,
    school_name: null,
    user_profile_id: null,
  });
  const sessionCookieName = '_ga_' + measurementId.replace('G-', '');
  document.cookie = sessionCookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export function trackContentView(content) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  trackPageView(content?.Title, window.location.pathname);
  window.gtag('event', 'content_view', {
    content_key_id: content?.KeyId,
    content_title: content?.Title,
    content_type: content?.ContentTypeId,
  });
}

export function trackContentDownload(content) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  window.gtag('event', 'content_download', {
    content_key_id: content?.KeyId,
    content_title: content?.Title,
    content_type: content?.ContentTypeId,
  });
}

export function trackContentShare(content, recipientCount) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  window.gtag('event', 'content_share', {
    content_key_id: content?.KeyId,
    content_title: content?.Title,
    content_type: content?.ContentTypeId,
    recipient_count: recipientCount,
  });
}

export function trackObservationEvent(eventName, observationId, extraProps) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  window.gtag('event', eventName, { observation_id: observationId, ...extraProps });
}

export function trackSurveyEvent(surveyId, surveyType, surveyName) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  window.gtag('event', 'survey_submitted', { survey_id: surveyId, survey_type: surveyType, survey_name: surveyName });
}

export function trackReportView(reportTitle, reportUrl) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  window.gtag('event', 'report_viewed', { report_title: reportTitle, report_url: reportUrl });
}

export function trackEchoAIQuery(entryPoint, queryLength, sessionQueryNumber) {
  if (typeof window.gtag !== 'function') return;
  if (!_isReady) return;
  window.gtag('event', 'echoai_query_submitted', { entry_point: entryPoint, query_length: queryLength, session_query_number: sessionQueryNumber });
}
